export default __webpack_public_path__ + "static/media/vips-politicians-and-bigshots.4827b264.jpg";